import React, { useRef, useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import css from './CreditWaitlistModal.module.scss';

export interface WaitlistConfirmScreenProps {
  rank?: number;
  shareUrl?: string;
  header?: string;
  description?: string;
  rankLabel?: string;
}

const WaitlistConfirmScreen = ({
  rank,
  shareUrl,
  header,
  description,
  rankLabel
}: WaitlistConfirmScreenProps) => {
  const shareUrlInputRef = useRef<HTMLInputElement>(null);
  const [copied, setCopied] = useState(false);

  const handleCopyClick = () => {
    if (shareUrlInputRef.current) shareUrlInputRef.current.select();
  };

  const handleCopySuccess = () => {
    setCopied(true);
    setTimeout(() => setCopied(false), 3000);
  };

  return (
    <>
      <h1
        className={css.title}
        data-testid="credit-waitlist-modal-confirm-title"
      >
        {header || 'Share the waitlist to be the first in line'}
      </h1>
      <p data-testid="credit-waitlist-modal-confirm-description">
        {description ||
          'The first 1,000 customers approved for the card will be eligible to earn $100 and 3 free months of Greenlight when they spend $750 in the first 90 days'}
        <sup>*</sup>
      </p>
      {rank && (
        <>
          <div
            className={css.positionLabel}
            data-testid="credit-waitlist-modal-confirm-rank-label"
          >
            {rankLabel || 'Your current position:'}
          </div>
          <div
            className={css.positionNumber}
            data-testid="credit-waitlist-modal-confirm-rank"
          >
            #{rank}
          </div>
        </>
      )}
      {shareUrl && (
        <>
          <p data-testid="credit-waitlist-modal-confirm-share">
            Share your unique referral link
          </p>
          <CopyToClipboard text={shareUrl} onCopy={handleCopySuccess}>
            <div
              className={css.shareUrlWrapper}
              onClick={handleCopyClick}
              data-testid="credit-waitlist-modal-confirm-url"
            >
              <input
                type="text"
                className={css.shareUrlInput}
                value={shareUrl}
                readOnly
                ref={shareUrlInputRef}
              />
              <button className={css.shareUrlCopyButton}>
                {copied ? 'Copied' : 'Copy'}
              </button>
            </div>
          </CopyToClipboard>
          <button
            className={css.socialShareButton}
            onClick={() => {
              window.open(
                (window as any).VL.popup.sharingOptions.mailLink,
                '_blank'
              );
              (window as any).VL.popup.email();
            }}
            data-testid="credit-waitlist-modal-confirm-email-button"
          >
            <img src="/static/icon-email.svg" alt="Share via email" />
          </button>
          <button
            className={css.socialShareButton}
            onClick={() => {
              window.open(
                `https://twitter.com/intent/tweet?url=${
                  (window as any).VL.options.twitterRefUrl
                }&text=myTweet`
              );
            }}
            data-testid="credit-waitlist-modal-confirm-twitter-button"
          >
            <img src="/static/icon-twitter.svg" alt="Share on Facebook" />
          </button>
          <button
            className={css.socialShareButton}
            onClick={() => {
              (window as any).VL.popup.share(520, 350);
            }}
            data-testid="credit-waitlist-modal-confirm-facebook-button"
          >
            <img src="/static/icon-facebook.svg" alt="Share on Facebook" />
          </button>
          <button
            className={css.socialShareButton}
            onClick={() => {
              (window as any).VL.popup.messenger();
            }}
            data-testid="credit-waitlist-modal-confirm-messenger-button"
          >
            <img
              src="/static/icon-facebook-messenger.svg"
              alt="Share on Facebook Messenger"
            />
          </button>
        </>
      )}
      <div
        className={css.footerText}
        data-testid="credit-waitlist-modal-confirm-footer"
      >
        <sup>*</sup>Subject to identity verification. Offer subject to change at
        any time.
      </div>
    </>
  );
};

export default WaitlistConfirmScreen;
